import http from "@/settings/apiSettings"

class GrupuriAngajatiService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/RU_GrupuriAngajati", data)
    }
}
export default new GrupuriAngajatiService()